import { Injectable } from '@angular/core';
import { ServiceBase } from '../service.base';
import { HttpClient } from '@angular/common/http';
import { AuthService, ResponseObject } from '../auth.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PlateformCurrencyExchangeRate } from '../Wix-Service/wix.service';
import { GalleryConsignmentProduct } from '../consignment.service';

@Injectable({
  providedIn: 'root'
})
export class WoocomerceService extends ServiceBase {
  private api = '/WooCommerce';

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService)
  }

  public hasAccountOnWooCommerce() {
    const httpOptions = this.RequestHeaders();
    const method: string = '/account-exists';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<WoocommerceCredentials>(url, httpOptions);
  }

  public allowProductSyncOnWooCommerce() {
    const httpOptions = this.RequestHeaders();
    const method: string = '/wooCommerce-product-synced';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<boolean>(url, httpOptions);
  }

  public onProductSynctWoocommerce(productId: string, consignmentId: string, IsUserAddManullyRates: boolean, WooCommerceAccountId: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method = `/sync-gallery-single-product/${productId}/${consignmentId}/${WooCommerceAccountId}/${IsUserAddManullyRates}`; // WooCommerceAccountId // IsUserAddManullyRates
    const url = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }

  public artistOnProductSyncWoocommerce(productId: string, WooCommerceAccountId: string, IsUserAddManullyRates: boolean): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method = `/sync-artist-single-product/${productId}/${WooCommerceAccountId}/${IsUserAddManullyRates}`; // WooCommerceAccountId // IsUserAddManullyRates
    const url = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }



  public createWoocommerceAccount(credentials: WoocommerceCredentials): Observable<ResponseObject> {
    const method = '/login-with-woocommerce';
    const url = `${environment.BASE_API_PATH}${this.api}${method}`;
    const httpOptions = this.RequestHeaders();
    return this.http.post<ResponseObject>(url, credentials, httpOptions);
  }

  public getWoocommerceAccountDetails(withAllDetail: boolean = true): Observable<StoreDetail[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/fetch-woocommerce-store-detail/${withAllDetail}`;

    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<StoreDetail[]>(url, httpOptions);
  }

  public disconnectWoocommerceAccount(WoocommerceAccountId: string): Observable<ResponseObject> {
    const method: string = `/Disconnect-Account/${WoocommerceAccountId}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    const httpOptions = this.RequestHeaders();
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }


  public storeCurrencyofWoocommerceWithExchangeRate(Id: string): Observable<PlateformCurrencyExchangeRate> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/fetch-store-currency-with-exchangeRate/${Id}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<PlateformCurrencyExchangeRate>(url, httpOptions);
  }

  public getWooCommerceSyncProducts(): Observable<GalleryConsignmentProduct[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/fetch-synced-products';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<GalleryConsignmentProduct[]>(url, httpOptions);
  }

  public removeSyncdProducts(productIds: string[]): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/remove-syncd-products';
    const url: string = environment.BASE_API_PATH + this.api + method;
    const body = {
      productSyncedOnPlatformIds: productIds
    };
    return this.http.post<ResponseObject>(url, body, httpOptions);
  }







}

export class WoocommerceCredentials {
  storeUrl!: string;
  CreatedAt!: Date;
}

export interface WooCommerceAccount {
  storeDetail: StoreDetail;
  responseObject: ResponseObject;
}

export interface StoreDetail {
  Id: string;
  StoreName: string;
  StoreURl: string;
  CreatedDate: string;
  AddressLine1: string;
  AddressLine2: string;
  City: string;
  CountryState: string;
  Postcode: string;
  SellingLocations: string;
  AllowedCountries: string[];
  EnableTaxes: string;
  EnableCoupons: string;
  Currency: string;
  CurrencyPosition: string;
}
